export enum NdsTagSize {
  COMPACT = 'compact',
  DEFAULT = 'default',
  BIG = 'big',
}

export enum NdsTagColor {
  NEUTRAL = 'neutral',
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  INFO = 'info',
  DANGER = 'danger',
  SUCCESS = 'success',
  PRIMARY_100 = 'primary-100',
  WARNING = 'warning',
  EMPTY = 'empty',
}

export enum NdsTagBorder {
  NONE = 'borderNone',
  SOLID = 'borderSolid',
  DASHED = 'borderDashed',
}
